import { Route } from '@angular/router';
import { SigninComponent } from './signin.component';



export const LOGIN_ROUTE: Route = {
  path: '',
  component: SigninComponent,
  data: {
    pageTitle: 'flowtechApp.login.title',
  },
  
};
